/**
 * A picked calendar day means "as things stood on {day}" — the instant sent to the
 * server is the END of that day in the viewer's local timezone, as a Z instant.
 */
export function dayToInstant(day: Date): Date {
  // Local-calendar constructor, NOT +86_399_999ms arithmetic: DST days are 23/25h long,
  // and the engine maps local 23:59:59.999 to the correct UTC instant either way.
  return new Date(day.getFullYear(), day.getMonth(), day.getDate(), 23, 59, 59, 999);
}

/**
 * The calendar day `months` months before `from`, day-of-month clamped to the target
 * month's length (May 31 → Apr 30). Feeds the panel's 1m/6m/1y preset chips.
 */
export function monthsBack(from: Date, months: number): Date {
  const year = from.getFullYear();
  const targetMonth = from.getMonth() - months;
  // Day 0 of the FOLLOWING month = the target month's last day (JS normalizes negatives).
  const lastDay = new Date(year, targetMonth + 1, 0).getDate();
  return new Date(year, targetMonth, Math.min(from.getDate(), lastDay));
}
